<template>
  <div>
    <Onboarding
      v-if="isVisible"
      targetSelector=".side-menu-novel-root"
      :message="message"
      :canOutsideClick="true"
      :tooltipPosition="'right-top'"
      maxWidth="460px"
      tooltipPadding="14px 20px"
      tooltipBorderRadius="15px"
      :isDisplayedCloseText="false"
      :triangleOffset="-110"
      @onboarding-outside-clicked="closeOnboarding"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, defineProps } from "vue";
import { useI18n } from "vue-i18n-bridge";
import Onboarding from "@/components/molecules/OnBoarding.vue";
import router from "@/router";

const { t } = useI18n();

const props = defineProps<{
  novelId: string;
}>();

const workCompletedImagePath = require("@/assets/img/onboarding/work_completed.png");
const closeIconImagePath = require("@/assets/img/onboarding/close_icon.png");

const isVisible = ref(true);

const message = computed(
  () => `
  <div
    style="
      position: relative;
      text-align: center;
      font-size: var(--font-size-sm);
      line-height: 1.1;
      margin-bottom: 16px;
      font-weight: var(--font-weight-regular);
    "
  >
    <div
      class="close-button"
      style="
        position: absolute;
        right: 0px;
        top: -5px;
        cursor: pointer;
        text-align: center;
      "
    >
      <img
        src="${closeIconImagePath}"
        style="width: 22px; height: auto; display: block; margin: 0 auto"
      />
      <span
        style="display: block; font-size: 8px; color: var(--color-text-low); margin-top: 6px; font-weight: var(--font-weight-bold);"
      >
        ${t('workStatusOnboarding.close')}
      </span>
    </div>
    <div style="margin-bottom: 10px">
      <img
        src="${workCompletedImagePath}"
        style="width: 130px; height: auto"
      />
    </div>
    <div style="line-height: 1.3;">
      ${t('workStatusOnboarding.bodyParagraph1')}<br /><br />
      ${t('workStatusOnboarding.bodyParagraph2')}<br /><br />
      ${t('workStatusOnboarding.bodyParagraph3')}
      <br /><br />
      ${t('workStatusOnboarding.cta')}
    </div>
  </div>
  <style>
    .edit-button {
      display: inline-block;
      background-color: var(--color-primary);
      color: var(--color-text-on-fixed-bg);
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-bold);
      padding: 10px 20px;
      border: none;
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-sm);
      cursor: pointer;
      margin-bottom: 16px;
    }
    .edit-button:hover {
      filter: brightness(0.9);
    }
  </style>
  <div style="text-align: center">
    <button
      class="edit-button"
    >
      ${t('workStatusOnboarding.editButton')}
    </button>
  </div>
`
);

// 閉じる処理
function closeOnboarding() {
  isVisible.value = false;
}

// 作品詳細画面に移動
function navigateToDetailScreen() {
  router.push({ name: "detail", params: { novelId: props.novelId } });
}

// DOM の準備完了後にイベントリスナーを登録
onMounted(() => {
  const closeButton = document.querySelector(".close-button");
  closeButton?.addEventListener("click", closeOnboarding);

  const editButton = document.querySelector(".edit-button");
  editButton?.addEventListener("click", navigateToDetailScreen);
});
</script>
